import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTableModule } from 'ng-zorro-antd/table';
import { Data } from '../../model/models';
import { MockDataService } from '../../mockdata/mock-data.service';

@Component({
  selector: 'data-provider-systems',
  standalone: true,
  imports: [CommonModule, NzTableModule, NzButtonModule, NzAffixModule, NzIconModule],
  templateUrl: './data-provider-systems.component.html',
  styleUrl: './data-provider-systems.component.scss'
})
export class DataProviderSystemsComponent {
  checked = false;
  loading = false;
  listOfData: Data[] = [];
  setOfCheckedId = new Set<string>();
  mockData = inject(MockDataService)

  ngOnInit(): void {
    this.loading = true
    setTimeout(() => {
      this.listOfData = this.mockData.getDataProviderSystems()
      this.loading = false
    }, 1000)
  }


  updateCheckedSet(id: string, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfData.every(({ id }) => this.setOfCheckedId.has(id));
  }

  onItemChecked(id: string, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }

  onAllChecked(checked: boolean): void {
    this.listOfData
      .forEach(({ id }) => this.updateCheckedSet(id, checked));
    this.refreshCheckedStatus();
  }

  sendRequest(): void {
    this.loading = true;
    const requestData = this.listOfData.filter(data => this.setOfCheckedId.has(data.id));
    console.log(requestData);
    setTimeout(() => {
      this.setOfCheckedId.clear();
      this.refreshCheckedStatus();
      this.loading = false;
    }, 800);
  }
}
